export default {
  tooltips: {
    expand: "展開",
    collapse: "收起",
    delete: "刪除",
    duplicateAddressMark: "地址重複標識",
  },
  remark: "備註",
};
